<template>
  <div class="container">
    <p style="text-align: center">
      <span style="font-size: 24px; font-weight: 700"> 《用户隐私协议》 </span>
    </p>
    <p>最近更新日期：2024年01月29日 生效日期：2024年01月31日</p>
    <p>
      欢迎使用大国工匠协同！您的信任对江苏大国工匠工业研究院有限公司（以下简称“我们”或“大国工匠”）非常重要，我们深知用户信息安全的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的用户信息安全可控。
    </p>
    <p>
      在使用我们的各项产品或服务前，请您务必仔细阅读并透彻理解本隐私政策，请在确认充分理解并同意后使用我们的产品或服务。
      一旦您开始使用我们的各项产品或服务，即表示您已充分理解并同意本隐私政策。如对本隐私政策内容有任何疑问、意见或建议，您可通过本隐私政策“八、如何联系我们”中披露的联系方式与我们联系。
    </p>
    <p></p>
    <p>本隐私政策部分将帮助您了解以下内容：</p>
    <p>一、适用范围</p>
    <p>二、我们如何收集和使用用户信息</p>
    <p>三、我们如何使用Cookie和同类技术</p>
    <p>四、我们如何共享、转让、公开披露用户信息</p>
    <p>五、我们如何保护用户信息</p>
    <p>六、我们如何管理用户信息</p>
    <p>七、未成年人的个人信息保护</p>
    <p>八、本隐私政策如何更新</p>
    <p>九、如何联系我们</p>
    <p>安卓操作系统第三方SDK列表说明</p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>一、适用范围</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >您需要注册大国工匠账号才能使用我们产品或服务中的特定功能。
        您在注册的时候应当同意大国工匠协同的用户协议与隐私政策，如对于本隐私政策隐私政策有任何疑问或意见，您可通过本隐私政策“八、如何联系我们”中披露的联系方式与我们联系，我们会尽快为您做出解答。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>二、我们如何收集和使用用户信息</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息。
        我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息。
        如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。
        在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：<br />
        1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用对应的产品及/或服务；<br />
        2、为实现向您提供我们产品及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。<br />
        我们会为您提供的各项具体功能场景包括：<br />
        （一）您需要授权我们收集和使用个人信息的场景<br />
        （1）账号注册、登录与验证,
        当您注册大国工匠账号时，您至少需要向我们提供您准备使用的手机号码、电子邮箱，我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。如您拒绝提供相应信息，您将无法正常使用对应的产品及/或服务；
        <br />
        （2）完善账号信息,
        您需提供<strong>姓名、性别、年龄、籍贯、婚姻状况、身份证号码、电子邮件地址、电话号码、联系地址</strong>等个人信息，以确保人事等模块相应业务的开展；
        <br />
        （二）您可以选择授权我们收集和使用个人信息的附加服务场景
        <br />
        在以下附加功能中，您可选择是否授权我们收集、使用您的个人信息。如果您拒绝提供部分功能或服务所需的信息，您将无法使用相关功能或服务，但不影响您正常使用其他功能或服务。您可在您的设备设置页面上逐项查看下述权限的状态，并可自行决定这些权限随时的开启或关闭。
        但是您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。<br />
        1．基于相机/摄像头的附加服务：当您使用我们的扫码识别商品条形码、扫描二维码信息、扫描发票/单据、查询库存、拍摄并上传头像功能时，<br />
        您需要同意开启相机权限并授权我们使用相机扫码或拍照功能。如您拒绝授权，我们将不能提供此附加服务。
        2．基于相册图片库的图片访问及上传的附加服务：当您使用我们的上传单据附件、服务提单上传附件图片、上传头像时，
        您需要开启相册权限并授权我们使用该相机功能上传您的照片/图片，以实现存储、信息上传的功能。<br />
        3、基于设备或软件信息或其拓展信息：<br />
        我们可能会收集您设备或软件专用的信息（例如您的硬件型号、操作系统版本、唯一设备标识符以及包括电话号码在内的移动网络信息），<br />
        我们可能会将您的设备标识符或电话号码与您的账户相关联。您可以选择开启设备的设备信息权限。经您授权，我们会收集您的设备信息<br />
        （包括<strong>设备属性、设备型号、设备标识符「如IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIM卡IMSI、ICCID信息」、设备MAC地址）</strong>，对风控问题进行分析、流量统计并排查可能存在的风险。<br />
        （三）征得授权同意的例外<br />
        您充分理解并同意，根据相关法律法规规定，我们在以下情形中收集、使用您的个人信息无需征得您的授权同意：<br />
        1）与我们履行法律、法规规定的义务相关的；<br />
        2）与国家安全、国防安全直接相关的；<br />
        3）与公共安全、公共卫生、重大公共利益直接相关的；<br />
        4）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br />
        5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
        6）您自行向社会公众公开的个人信息；<br />
        7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br />
        8）根据与您签订和履行相关协议或其他书面文件所必需的；<br />
        9）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；<br />
        10）法律法规规定的其他情形。<br />
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>三、我们如何使用Cookie和同类技术</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >为使您获得更便捷的访问体验，您使用大国工匠协同产品或服务时，我们会通过采用各种技术收集和存储您的相关数据，包括使用小型数据文件识别您的身份，在您再次访问大国工匠协同产品或服务时,我们能识别您的身份，并通过分析数据为您提供更好更多的服务，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、Flash
        Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
        请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝使用Cookie，但拒绝Cookie在某些情况下您可能无法使用部分依赖于cookie的功能。</span
      >
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>四、我们如何共享、转让、公开披露用户信息</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >（一）共享<br />
        我们不会与大国工匠以外的公司、组织和个人共享用户信息，但以下情况除外：<br />
        1．在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的信息。<br />
        2．在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的信息。<br />
        3．在您主动选择情况下共享：您通过我们的平台订购产品与服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关产品或服务的提供者，以实现您的交易及售后服务需求。<br />
        <br />
        （二）转让<br />
        我们不会将您的信息转让给任何公司、组织和个人，但以下情况除外：<br />
        1．在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的信息。<br />
        2．在我们产品及或服务的提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您信息的公司、组织和个人继续受本隐私政策的约束，
        否则我们将要求该公司、组织和个人重新向您征求授权同意。
        <br />（三）公开披露<br />
        我们仅会在以下情况下，公开披露用户信息：<br />
        1．获得您明确同意或基于您的主动选择，我们可能会公开披露您的信息；<br />
        2．如果我们确定您出现违反法律法规或严重违反本隐私政策、平台规则的情况，或为保护我们及其他用户、公众的人身财产安全免遭侵害，我们在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，可能会公开披露您的信息。<br />
        （四）共享、转让、公开披露用户信息时事先征得授权同意的例外<br />
        根据相关法律法规、监管规定，我们可能会共享、转让、公开披露用户信息而无需事先征得您授权同意：<br />
        1.与国家安全、国防安全直接相关的；<br />
        2.与公共安全、公共卫生、重大公共利益直接相关的；<br />
        3.与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />
        4.出于维护您或其他个人的生命、财产安全所必需的；<br />
        5.所处理的个人信息是您自行公开或属于其他已经合法公开的个人信息的；<br />
        6.为履行我行法定职责或法定义务所必需的；<br />
        7.为订立、履行您作为一方当事人的合同所必需的，或按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需的；<br />
        8.用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br />
        9.法律法规及监管规定要求的其他情形。<br />
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>五、我们如何保护用户信息</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >我们已采取符合业界标准、合理可行的安全防护措施保护用户信息安全，防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失，
        我们提供HTTPS协议安全浏览方式；我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，
        尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>六、我们如何管理用户信息</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >您可以通过以下方式访问及管理您的信息： <br />（一）访问您的信息<br />
        您有权访问您的信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的信息：
        对于大国工匠协同App，您可以通过在大国工匠协同App中点击“我的”页面，再点击设置图标，进入设置功能页面，再点击“修改密码”进行账号密码的修改。
        如您有其他需求，请联系第九条列明的联系方式联系我们处理。
        如果您无法通过上述路径访问该等用户信息，您可以随时通过本隐私政策第九条披露的联系方式与我们取得联系。我们将在15天内回复您的访问请求。
        对于您在使用我们的产品及或服务过程中产生的其他信息，我们将根据本条“（八）响应您的上述请求”中的相关安排向您提供。<br />
        （二）更正或补充您的信息<br />
        当您发现我们处理的关于您的信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的信息”中列明的方式进行更正或补充。您也可以通过本隐私政策第九条披露的联系方式与我们取得联系，我们将在15天内回复您的请求。<br />
        （三）删除您的信息<br />
        您可以通过“（一）访问您的信息”中列明的方式删除您的部分信息。<br />
        在以下情形中，您可以向我们提出删除信息的请求：<br />
        1．如果我们处理信息的行为违反法律法规；<br />
        2．如果我们收集、使用您的信息，却未征得您的明确同意；<br />
        3．如果我们处理信息的行为严重违反了与您的约定；<br />
        4．如果您不再使用我们的产品及或服务，或您主动注销了账号；<br />
        5．如果我们永久不再为您提供产品及或服务。<br />
        您可以通过本隐私政策第九条披露的联系方式联系我们删除。若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的信息的第三方，要求其及时删除，除非法律法规另有规定，或这些第三方获得您的独立授权。
        当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。<br />
        （四）改变您授权同意的范围<br />
        我们产品或服务的每个业务功能可能需要一些基本用户信息才能得以完成（见本隐私政策“第二部分”）。除此之外，对于额外用户信息的收集和使用，您可以在大国工匠协同App
        “我的”页面，点击“设置”图标，选择撤回对隐私政策的同意，或者通过我们的客服热线电话：0755-86500666或通过第九条列明的其他方式联系我们撤回您对隐私政策内容的部分或全部同意。
        请您注意，您注销您的账户的同时，将视同您撤回了对本隐私政策全部内容的同意。当您撤回同意后，我们将不再处理相应的用户信息。但您收回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。<br />
        （五）用户注销账号<br />
        当您所在的企业用户注销企业账户时，我们会匿名化或删除您在该企业的相关个人信息，但您的个人信息将被保留，除非您主动按照如下方式申请注销您的个人账户。在您主动向我们提出申请注销账户后，我们将在账号注销完成后停止为您提供服务
        ，并根据适用法律法规的要求删除您的个人信息或进行匿名化处理。
        如您的账号是所在企业的创始人账号，您应当先转移企业至其他账号或删除该企业，您才能申请注销账号。
        申请注销账号服务邮箱：3t@123-ai.cn，邮箱内容注明：注销账号手机号和企业名称。
        我们收到您的账号注销申请后，将在15天内完成核查与处理。
        关于账号注销，如您有任何疑问，可以联系我们的客服热线电话：0755-86500666或通过第九条列明的其他方式与我们取得联系。<br />
        （六）获取用户信息副本<br />
        您有权获取您的信息副本，您可以通过以下方式自行操作：我们在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的信息副本传输给您指定的第三方。<br />
        （七）约束信息系统自动决策<br />
        在我们产品及或服务的某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我们商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
        <br />（八）响应您的上述请求<br />
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
        我们将在15天内做出答复。如您不满意，还可以通过联系我们发起投诉。
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br />
        1．与国家安全、国防安全有关的；<br />
        2．与公共安全、公共卫生、重大公共利益有关的；<br />
        3．与犯罪侦查、起诉、审判和执行判决等有关的；<br />
        4．有充分证据表明用户存在主观恶意或滥用权利的；<br />
        5．响应用户的请求将导致用户或其他个人、组织、公司的合法权益受到严重损害的；<br />
        6．涉及商业秘密的。<br />
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>七、未成年人的个人信息保护</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >如果您是未满18周岁的个人用户，请在法定监护人的陪同下阅读并在法定监护人同意的前提下接受本隐私政策，
        并特别注意未成年人使用条款。对于经法定监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许，
        法定监护人明确同意或者保护未成年人所必要的情况下使用，共享，转让或披露此信息。我们将根据国家相关法律法规及本隐私政策的规定保护未成年人的个人信息。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>八、本隐私政策如何更新</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >我们的隐私政策可能变更。未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。我们会在平台上发布对隐私政策所做的任何变更。<br />
        对于重大变更，我们还会提供更为显著的通知（包括我们会通过我们公示的方式进行意见征集、公告通知甚至向您提供弹窗提示）。<br />
        本隐私政策所指的重大变更包括但不限于：<br />
        1．我们的产品及或服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br />
        2．我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；<br />
        3．个人信息共享、转让或公开披露的主要对象发生变化；<br />
        4．您参与个人信息处理方面的权利及其行使方式发生重大变化；<br />
        5．我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；<br />
        6．个人信息安全影响评估报告表明存在高风险<br />
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>九、如何联系我们</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >如对本政策内容有任何疑问、意见或建议，或如发现个人信息可能被泄露，您可以通过以下方式与我们联系:<br />
        客服热线电话：18823679841<br />
        地址：江苏省昆山市高新区玉带北路285号3号房<br />
        邮编：215000
        <br />
        官网:
        <a
          style="word-break: break-all"
          target="_blank"
          href="http://bi.123-ai.cn"
          >http://bi.123-ai.cn</a
        ><br />
        电子邮箱：dggj@123-ai.cn
      </span>
    </p>
    <p>安卓操作系统第三方SDK列表说明</p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">极光推送</span>
      </strong>
      <br />
      使用目的：用于消息推送<br />
      使用场景：用户账户相关通知公告，单据状态提醒，为提升消息的送达率，<br />
      及时地为您进行消息提醒，我们会默认为您开启关联启动功能，以保持应用的活跃度,
      <br />
      为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，<br />
      将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。<br />
      个人信息收集类型：<strong>设备标识符（包括IMEI、IDFA、AndroidID、GAID、MAC、OAID、IMSI、MEID、UAID）、<br />
      设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称）、</strong><br />
      操作系统信息（包括操作系统版本、系统名称、系统语言）、<br />
      网络信息（包括网络类型、运营商名称、基站信息、IP地址、WiFi信息、SSID、BSSID）、<br />
      推送信息日志、精确位置信息、软件列表信息（包括软件列表及软件运行列表信息）<br />
      第三方公司名称：深圳市和讯华谷信息技术有限公司<br />
      隐私政策链接：<a
        style="word-break: break-all"
        target="_blank"
        href="https://www.jiguang.cn/license/privacy"
        >https://www.jiguang.cn/license/privacy</a
      ><br /><br />
      <strong>
        <span style="font-family: 黑体; font-size: 18px">小米推送</span>
      </strong>
      <br />
      使用目的：用于消息推送<br />
      使用场景：用户账户相关通知公告，单据状态提醒，为提升消息的送达率，<br />
      及时地为您进行消息提醒，我们会默认为您开启关联启动功能，以保持应用的活跃度,
      <br />
      为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，<br />
      将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。<br />
      个人信息收集类型：设备标识(OAID、加密的Android
      ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置<br />
      第三方公司名称：北京小米移动软件有限公司<br />
      隐私政策链接：<a
        style="word-break: break-all"
        target="_blank"
        href="https://dev.mi.com/console/doc/detail?pId=1822"
        >https://dev.mi.com/console/doc/detail?pId=1822</a
      ><br /><br />
      <strong>
        <span style="font-family: 黑体; font-size: 18px">高德地图SDK</span>
      </strong>
      <br />
      使用目的：用于定位打卡<br />
      使用场景：用户外出外出定位打卡<br />
      个人信息收集类型：位置信息，设备和运营商信息<br />
      第三方公司名称：高德软件有限公司<br />
      隐私政策链接：<a
        style="word-break: break-all"
        target="_blank"
        href="https://lbs.amap.com/pages/privacy/"
        >https://lbs.amap.com/pages/privacy/</a
      ><br /><br />
      <strong>
        <span style="font-family: 黑体; font-size: 18px">腾讯TBS浏览服务</span>
      </strong>
      <br />
      使用目的：加载网页页面 使用场景:打开网页页面时<br />
      个人信息收集类型：Wifi信息、MAC地址、IMSI、bssid、IMEI、设备序列号、android_id<br />
      第三方公司名称：深圳市腾讯计算机系统有限公司<br />
      隐私政策链接：<a
        style="word-break: break-all"
        target="_blank"
        href="https://x5.tencent.com/tbs/policy.html"
        >https://x5.tencent.com/tbs/policy.html</a
      ><br /><br />
      <strong>
        <span style="font-family: 黑体; font-size: 18px">华为统一扫码SDK</span>
      </strong>
      <br />
      使用目的：为开发者应用提供码生成或扫码等能力 使用场景:
      扫码二维码、条形码时<br />
      个人信息收集类型：文字信息、图片、网络信息、应用基本信息、运营商信息、设备的硬件信息、设备型号、操作系统、系统设置信息、有关您使用本应用的信息<br />
      第三方公司名称：华为软件技术有限公司<br />
      隐私政策链接：
      <a
        style="word-break: break-all"
        target="_blank"
        href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050043971"
        >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050043971</a
      >
      <br /><br />
      <strong>
        <span style="font-family: 黑体; font-size: 18px">崩溃分析</span>
      </strong>
      <br />
      使用目的：用于崩溃日志的上报及分析<br />
      使用场景: 崩溃信息上报<br />
      个人信息收集类型：网络信息，设备信息包括IMEI，Android系统设备标识<br />
      第三方公司名称：阿里云计算有限公司<br />
      隐私政策链接：<a
        style="word-break: break-all"
        target="_blank"
        href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=5176.13194971.help.11.5acbcb3cNvklL0"
        >https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=5176.13194971.help.11.5acbcb3cNvklL0</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "ros-com-privacy-agreement",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.container {
  margin: 20px auto;
  text-align: initial;
  max-width: 1200px;
  font-family: 宋体;
  font-size: 14px;
  height: auto;
}
p {
  line-height: 35px;
}
@media (max-width: 768px) {
  .container {
    font-size: 12px !important;
    color: #555;
    padding: 0 5%;
    width: 90%;
    background: rgb(14, 80, 177);
    margin-top: 0;
    .container {
      background-color: #fff;
      border-radius: 10px;
      padding-top: 20px;
      margin-top: 20px;
    }
    .wrapper {
      .container {
        background: none;
      }
    }
  }
}
</style>
